export default __webpack_public_path__ + "static/media/item-detail-1.9afb3a62.jpg";